<template>
  <div class="pc-note__sidebar-details" v-show="!folded">
    <slot/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      isFolded: 'workbench/isFolded'
    }),
    folded () {
      return this.isFolded(this.name)
    }
  }
}
</script>
